import { Injectable } from '@angular/core';
// import { StatisticConsumerState } from '../reg-statistics/reg-statistics.component';

@Injectable()
export class RegServiceService {

  private moneyFlowsSend: string = "moneyFlowsSend";
  private moneyFlowsReceive: string = "moneyFlowsReceive";
  private statisticsConsumer: string = "statisticsConsumer";
  private statisticsTransaction: string = "statisticsTransaction";
  private pricing:string="pricing";
  private compliance:string="compliance";

  constructor() { }

  setMoneyFlowsSend(data: any) {
    localStorage.setItem(this.moneyFlowsSend, JSON.stringify(data));
  }

  setMoneyFlowsReceive(data: any) {
    localStorage.setItem(this.moneyFlowsReceive, JSON.stringify(data));
  }

  setStatisticsConsumer(data:any) {
    
    
    
    localStorage.setItem(this.statisticsConsumer, JSON.stringify(data));
  }

  setStatisticsTransaction(data: any) {
    localStorage.setItem(this.statisticsTransaction, JSON.stringify(data));
  }

  setPricing(data: any) {
    localStorage.setItem(this.pricing, JSON.stringify(data));
    alert(localStorage.getItem(this.pricing));
  }

  setCompliance(data: any) {
    localStorage.setItem(this.compliance, JSON.stringify(data));
  }




  getMoneyFlowsSend() {
    let data = localStorage.getItem(this.moneyFlowsSend);
    return JSON.parse(data!);
  }

  getMoneyFlowsReceive() {
    let data = localStorage.getItem(this.moneyFlowsReceive);
    return JSON.parse(data!);
  }

  getStatisticsConsumer() {
    let data = localStorage.getItem(this.statisticsConsumer);
    return JSON.parse(data!);
  }

  getStatisticsTransaction() {
    let data = localStorage.getItem(this.statisticsTransaction);
    return JSON.parse(data!);
  }

  getPricing() {
    let data = localStorage.getItem(this.pricing);
    
    return JSON.parse(data!);
  }
  getCompliance() {
    let data = localStorage.getItem(this.compliance);
    return JSON.parse(data!);
  }






  // clearUserSettings() {
  //   localStorage.removeItem(this.storageName);
  // }

  cleanAll() {
    localStorage.clear()
  }



}
